import React from 'react';
import { Artist } from '../../types/artist';
import './ArtistProfile.css';

interface ArtistProfileProps {
  artist: Artist;
  onEdit: () => void;
  onDelete: (artistId: number) => void;
}

export const ArtistProfile: React.FC<ArtistProfileProps> = ({ artist, onEdit, onDelete }) => {
  const hasLocation = artist.city || artist.state || artist.country;
  const hasSocialLinks = artist.soundcloudUrl || artist.bandcampUrl || artist.instagramUrl || 
                         artist.youtubeUrl || artist.tikTokUrl || artist.linktreeUrl;

  return (
    <div className="artist-profile-container">
      <div className="artist-profile-header">
        <h2 className="artist-profile-title">{artist.name}</h2>
        <div className="artist-profile-actions">
          <button onClick={onEdit} className="artist-edit-button">
            Edit Profile
          </button>
        </div>
      </div>

      {/* Profile Image */}
      {artist.profileImageUrl && (
        <div className="artist-profile-image-section">
          <img 
            src={artist.profileImageUrl} 
            alt={artist.name} 
            className="artist-profile-image"
          />
        </div>
      )}

      {/* Combined Info Box */}
      <div className="artist-profile-section">
        <h3 className="artist-profile-section-title">Artist Information</h3>
        
        {/* Karma */}
        <div className="artist-detail-row">
          <span className="artist-detail-label">Karma:</span>
          <span className="artist-detail-value artist-karma">{artist.karma}</span>
        </div>

        {/* AI Usage */}
        {artist.usesAI && (
          <div className="artist-detail-row">
            <span className="artist-detail-label">Uses AI:</span>
            <span className="artist-detail-value">Yes</span>
          </div>
        )}

        {/* Location */}
        {hasLocation && (
          <div className="artist-detail-row">
            <span className="artist-detail-label">Location:</span>
            <div className="artist-location">
              {artist.city && <span>{artist.city}</span>}
              {artist.state && <span>{artist.state}</span>}
              {artist.country && <span>{artist.country}</span>}
            </div>
          </div>
        )}

        {/* Bio */}
        {artist.bio && (
          <div className="artist-bio-section">
            <span className="artist-detail-label">Bio:</span>
            <p className="artist-bio">{artist.bio}</p>
          </div>
        )}
      </div>

      {/* Social Links */}
      {hasSocialLinks && (
        <div className="artist-profile-section">
          <h3 className="artist-profile-section-title">Social Links</h3>
          <div className="artist-social-links">
            {artist.soundcloudUrl && (
              <a href={artist.soundcloudUrl} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/img/soundcloud.png" alt="SoundCloud" className="social-icon" /> SoundCloud
              </a>
            )}
            {artist.bandcampUrl && (
              <a href={artist.bandcampUrl} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/img/bandcamp.png" alt="Bandcamp" className="social-icon" /> Bandcamp
              </a>
            )}
            {artist.instagramUrl && (
              <a href={artist.instagramUrl} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/img/instagram.png" alt="Instagram" className="social-icon" /> Instagram
              </a>
            )}
            {artist.youtubeUrl && (
              <a href={artist.youtubeUrl} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/img/youtube.png" alt="YouTube" className="social-icon" /> YouTube
              </a>
            )}
            {artist.tikTokUrl && (
              <a href={artist.tikTokUrl} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/img/tiktok.png" alt="TikTok" className="social-icon" /> TikTok
              </a>
            )}
            {artist.linktreeUrl && (
              <a href={artist.linktreeUrl} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src="/img/linktree.png" alt="Linktree" className="social-icon" /> Linktree
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};